@if (!useDualList) {
  <forge-select multiple="true" [disabled]="isViewOnly" [label]="Label" [name]="Name"
    attr.telemetry="Submission-{{Label}}" (change)="fireValueChanged($event)" [invalid]="isInvalid"
    [required]="isRequired" [(ngModel)]="selected" [value]="selected">
    @for (item of options; track item) {
      <forge-option [value]="item.Key">{{item.Value}}</forge-option>
    }
    @if (!dense) {
      <span slot="support-text" [hidden]="!hint">{{hint}}</span>
    }
    @if (!dense) {
      <span slot="support-text" class="error-red">{{error}}</span>
    }
  </forge-select>
}
@if (useDualList) {
  <div>
    @if (compact) {
      <label for="mlt-{{Name}}" class="forge-typography--label1 compact-mode--label"
        [ngClass]="{'compact-mode--label-required': isRequired, 'compact-mode--label-invalid': error.length > 0}">{{Label}}
      </label>
    }
    <div fxLayout="row" fxLayoutAlign="space-between start">
      <forge-text-field class="multiselect" [required]="isRequired" [invalid]="isInvalid" style="width: 100%;"
        [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}" [attr.aria-label]="Name"
        [density]="Density" id="multiselect-text-field-{{popupId}}" role="combobox"
        attr.aria-controls="multi-select-{{popupId}}-popover" popover-icon [popoverExpanded]="popover.open"
        [attr.shape]="forCellEdit ? 'squared' : null" (forge-field-popover-icon-click)="openPopup(false)">
        <input readonly class="multiselect-input popup-target" [ngModel]="selectedCount" type="text"
          id="mlt-{{popupId}}" [required]="isRequired" [invalid]="isInvalid"
          [disabled]="isViewOnly" (keydown)="textContainerKeydown($event)"
          forgePopoverCloseOnBlur="true" (click)="openPopup(false)" [name]="Name"
          attr.telemetry="Submission-{{Label}}" autocomplete="off">
          @if (!compact && !forCellEdit) {
            <label for="mlt-{{Name}}">{{Label}}</label>
          }
          @if (hint && !dense && !compact) {
            <span slot="support-text">{{hint}}</span>
          }
          @if (error && !dense && !compact) {
            <span slot="support-text" class="error-red">{{error}}</span>
          }
          @if (showSpinner) {
            <forge-circular-progress class="metadata-input--spinner" slot="end">
            </forge-circular-progress>
          }
        </forge-text-field>
        <forge-popover #popover anchor="multiselect-text-field-{{popupId}}" id="multi-select-{{popupId}}-popover"
          placement="bottom" position-strategy="fixed" (forge-popover-toggle)="togglePopover($event)">
          @if (popover.open) {
            <div #popupContent id="multi-select-{{popupId}}" class="popup-container">
              <div class="popup-card multi-select">
                <div fxLayout="row">
                  <div fxLayout="column" style="width: 100%;">
                    <div fxLayout="row" fxLayoutAlign="space-between center" style="margin: 16px 16px 0;">
                      <forge-text-field style="width: 100%;" [ngClass]="{'dense-input': compact}" [density]="Density"
                        show-clear (forge-text-field-clear)="clearOptionSearch()">
                        <input #searchFilter type="text" id="searchFilter-{{Name}}" name="searchFilter-{{Name}}"
                          class="multi-select--search-field" attr.telemetry="Search-Tree"
                          (keydown)="trapTab($event)" attr.aria-label="search options for {{Name}}"
                          [(ngModel)]="optionSearch" (change)="loadMoreCount = 1" autocomplete="off">
                          <label for="searchFilter-{{Name}}">Search options</label>
                        </forge-text-field>
                        <div fxLayout="row" fxLayoutAlign="flex-end center">
                          <forge-icon-button [dense]="compact ? '' : undefined" (click)="sort()"
                                        [disabled]="isViewOnly" style="margin-left: 8px;" aria-label="Toggle sort order">
                            <forge-tooltip placement="bottom">Toggle sort order</forge-tooltip>
                            <forge-icon name="sort_alt"></forge-icon>
                          </forge-icon-button>
                          <forge-icon-button [dense]="compact ? '' : undefined" aria-label="selectAllText(false)"
                            (click)="selectAll()" [disabled]="isViewOnly" style="margin-left: 8px;">
                            <forge-tooltip placement="bottom">{{selectAllText(false)}}</forge-tooltip>
                            <forge-icon name="checkbox_multiple_marked"></forge-icon>
                          </forge-icon-button>
                          <forge-icon-button [dense]="compact ? '' : undefined" aria-label="selectAllText(true)"
                            (click)="deselectAll()" [disabled]="isViewOnly"
                            id="select-all-button-{{popupId}}" style="margin-left: 8px;">
                            <forge-tooltip placement="bottom">{{selectAllText(true)}}</forge-tooltip>
                            <forge-icon name="checkbox_multiple_blank_outline"></forge-icon>
                          </forge-icon-button>
                        </div>
                      </div>
                      <forge-card class="multiselect-list-card--first no-padding" [id]="multiSelectListSelectId"
                        style="margin-top: 8px; max-height: 25vh;">
                        <forge-scaffold>
                          <forge-list slot="body" [dense]="compact ? '' : undefined">
                            @for (item of selectList; track item) {
                              <forge-list-item [value]="item.Key"
                                propagate-click="false" [disabled]="isViewOnly">
                                <forge-checkbox slot="start" style="--forge-list-item-leading-margin-right: 0;"
                                  [disabled]="isViewOnly" attr.aria-label="{{item.Value}}"
                                  (change)="selectItem(item.Key)" [checked]="isItemChecked(item.Key)">
                                </forge-checkbox>
                                <truncate-text class="tyl-list-item__text"
                                  [ngClass]="{'disabled-input': isViewOnly}" [mainText]="item.Value">
                                </truncate-text>
                              </forge-list-item>
                            }
                          </forge-list>
                        </forge-scaffold>
                      </forge-card>
                      <forge-button fxLayout="row" fxLayoutAlign="end end" variant="text" (click)="closePopup()"
                        (keydown)="closeButtonKeyDown($event)" aria-label="Close multiselect"
                        id="close-button-{{popupId}}">Close
                      </forge-button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </forge-popover>
        </div>
      </div>
    }
